<div class="files-container" #filesContainer>
  @for (file of files; track file; let i = $index) {
    <div class="file-preview">
      @if (file.fileTypeShort === 'image') {
        @if (!file.error) {
          <img (load)="onFileLoaded(file)" class="image" [class.visible]="file.loaded" [src]="file.fileUrl" />
          <div *ngIf="!file.loaded" class="img-loader"></div>
        }
        @if (file.error) {
          <div *ngIf="!file.loaded" class="file-error-state">
            Un-<br />
            supported<br />
            file
          </div>
        }
      } @else if (file.type === 'application/pdf') {
        <div class="file-preview--pdf">
          <img [src]="fileIconSvg['pdf']" />
          <span
            #fileNameElement
            textOverFlowTooltip="max-width"
            [matTooltip]="file.name || ''"
            [matTooltipDisabled]="fileNameElement.classList.contains('disableTooltip')"
            matTooltipClass="custom-tooltip-black"
            matTooltipPosition="above">
            {{ file.name }}
          </span>
        </div>
      } @else {
        <div class="file-preview--pdf">
          <img [src]="fileIconSvg['other']" />
          <span
            #fileNameElement
            textOverFlowTooltip="max-width"
            [matTooltip]="file.name || ''"
            [matTooltipDisabled]="fileNameElement.classList.contains('disableTooltip')"
            matTooltipClass="custom-tooltip-black"
            matTooltipPosition="above">
            {{ file.name }}
          </span>
        </div>
      }

      <button
        class="remove-button"
        [class.error]="file.error"
        type="button"
        [class.image]="file.fileTypeShort === 'image'"
        (click)="onDelete(i)">
        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none">
          <path d="M5 5L1 1M5 1L1 5" stroke="#343E57" stroke-linecap="round" />
        </svg>
      </button>
    </div>
  }
  <div class="loader-container" *ngIf="loading">
    <img src="assets/loading-circle-blue-animated.svg" />
  </div>
</div>
<div class="error-block" *ngIf="displayMaxFilesError">
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
    <g clip-path="url(#clip0_5056_21866)">
      <path
        d="M8.50008 15.7499C12.4121 15.7499 15.5834 12.5786 15.5834 8.66658C15.5834 4.75457 12.4121 1.58325 8.50008 1.58325C4.58806 1.58325 1.41675 4.75457 1.41675 8.66658C1.41675 12.5786 4.58806 15.7499 8.50008 15.7499Z"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round" />
      <path d="M8.5 11.5V8.66663" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8.5 5.83325H8.50708" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_5056_21866">
        <rect width="17" height="17" fill="white" transform="translate(0 0.166626)" />
      </clipPath>
    </defs>
  </svg>
  <span>You can upload up to 5 files at a time</span>
</div>
<div class="input-divider"></div>
